module.exports = __webpack_public_path__ + "static/media/Dashboard.79795fdb.svg";